import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

export const TypingIndicator: React.FC<{ compact?: boolean }> = ({
  compact = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: compact ? 0 : theme.spacing(1),
        marginBottom: compact ? '12px' : theme.spacing(2),
        width: '100%',
      }}
    >
      <Card
        elevation={0}
        sx={{
          backgroundColor: 'transparent',
          border: `0px solid ${theme.palette.background.paper}`,
          maxWidth: compact ? '269px' : '70%',
        }}
      >
        <CardContent
          sx={{
            padding: compact
              ? '10px 0'
              : `${theme.spacing(1.5)}px ${theme.spacing(2)}px`,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="body2"
              fontSize="0.875rem"
              sx={{
                marginLeft: compact ? 0 : 1,
                color: theme.palette.text.secondary,
                '&::after': {
                  content: '"."',
                  animation: 'dots 1.5s steps(3, end) infinite',
                },
                '@keyframes dots': {
                  '0%': { content: '"."' },
                  '33%': { content: '".."' },
                  '66%': { content: '"..."' },
                },
              }}
            >
              xpert is gathering information
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
